import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { useFormatGoalAmount } from "web_myplann/Goals/Helpers/formatGoalAmount";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	ownFunds: number;
	currencyCode?: CurrencyEnum;
	onClose: () => void;
	onAssign: () => void;
};

export const GoalCreatedPinDrawer: FC<Props> = ({
	open,
	ownFunds,
	currencyCode,
	onClose,
	onAssign,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { t } = useResource();
	const formatAmount = useFormatGoalAmount();
	const hasOwnFunds = ownFunds > 0;

	const description = hasOwnFunds
		? t(Resources.Goals.Detail.WelcomePin.WithOwnFunds.description, {
				amount: formatAmount(ownFunds, currencyCode),
			})
		: t(Resources.Goals.Detail.WelcomePin.WithoutOwnFunds.description);

	const ctaLabel = hasOwnFunds
		? t(Resources.Goals.Detail.WelcomePin.WithOwnFunds.cta)
		: t(Resources.Goals.Detail.WelcomePin.WithoutOwnFunds.cta);

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(Resources.Goals.Detail.WelcomePin.title)}
		>
			<Stack px={spacingTokens.lg} pb={2.4} gap={2}>
				<Typography variant="body2" color={palette.grey[600]}>
					{description}
				</Typography>
				<Stack gap={1}>
					<Button variant="primary" onClick={onAssign}>
						{ctaLabel}
					</Button>
					<Button variant="secondary" onClick={onClose}>
						{t(Resources.Goals.Detail.WelcomePin.dismiss)}
					</Button>
				</Stack>
			</Stack>
		</MyPlannDrawer>
	);
};
